import { memo } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import type { CrmQuestionnaireLatestResponseItem } from "../types";

export interface CrmLatestQuestionnaireResponsesDialogProps {
  open: boolean;
  items: CrmQuestionnaireLatestResponseItem[];
  onClose: () => void;
}

const CrmLatestQuestionnaireResponsesDialog = memo<
  CrmLatestQuestionnaireResponsesDialogProps
>(({ open, items, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        Últimas respostas
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary">
            Esta lista é simulada. Em breve, virá de uma API com paginação e
            link para visualizar a resposta completa.
          </Typography>

          <Divider />

          {items.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nenhuma resposta recente encontrada.
            </Typography>
          ) : (
            <List dense disablePadding>
              {items.map((item) => (
                <ListItem
                  key={item.id}
                  sx={{
                    px: 0,
                    py: 1,
                    borderBottom: "1px dashed",
                    borderColor: "divider",
                    "&:last-of-type": { borderBottom: "none" },
                  }}
                >
                  <ListItemText
                    primary={
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="baseline"
                        spacing={1}
                      >
                        <Typography variant="body2" fontWeight={700}>
                          {item.patientName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {item.receivedRelativeDescription}
                        </Typography>
                      </Stack>
                    }
                    secondary={
                      <Stack spacing={0.5} sx={{ mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary">
                          {item.questionnaireTitle}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {item.highlightText}
                        </Typography>
                      </Stack>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

CrmLatestQuestionnaireResponsesDialog.displayName =
  "CrmLatestQuestionnaireResponsesDialog";

export default CrmLatestQuestionnaireResponsesDialog;

